/* eslint-disable no-unused-vars */
/* eslint-disable no-const-assign */
import React, { useState, useEffect, useRef } from "react";
import "./../../../assets/css/purchase/form.css";
import "./../../../assets/css/reports/vansale-report.css";
import moment from "moment";
import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import {
  formatCurrency,
  getAlert,
  getCompany,
  getData,
  getDataWithComp,
  getDataWithJoin,
  parseCurrency,
} from "../../../utils/SamuiUtils";
import { getReport } from "../../../utils/ReportUtils";
import Pagination from "../../components/Footer/Pagination";
import { formatDateCheque } from "../../../utils/DateUtils";
import { isValidReportRange, reportDateCondition, buildVansaleWhere } from "../../../utils/VansaleReportUtils";
import DatePicker from "../../components/DatePicker";
import CloseVansaleForAccountModal from "../../components/Modal/CloseVansaleForAccountModal";
import { ExportVansaleIncomeReport } from "../../../utils/ExportUtils";
import { 
  useDataTableKeyboardNavigation, 
  getDataTableRowStyle, 
  getDataTableKeyboardInstructions 
} from '../../../utils/DataTableKeyboardNavigation';

const VansaleReport = () => {
  const isIce = typeof window !== 'undefined' && localStorage.getItem('company') === '2';
  const [name, setName] = useState(null);

  const [filteredData, setFilteredData] = useState([]);
  const [filteredDataSub, setFilteredDataSub] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(16);
  const [itemsPerPageDropdown, setItemsPerPageDropdown] =
    useState(itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setSelectedRowIndex(0);
  };

  // Handle row selection
  const onRowSelected = (data) => {
    setSelectedRow(data);
  };

  // Field mappings for keyboard navigation
  const fieldMappings = {
    id: 'PK_Doc_Id'
  };

  // Keyboard navigation
  useDataTableKeyboardNavigation(
    true, // isActive
    currentItems,
    selectedRowIndex,
    setSelectedRowIndex,
    onRowSelected,
    fieldMappings,
    currentPage,
    handlePageChange,
    filteredData.length,
    itemsPerPage,
    () => handlePrintReport()
  );

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [searchDocDate, setSearchDocDate] = useState(moment().format("YYYY-MM-DD"));
  const [searchEndDate, setSearchEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [appliedSearch, setAppliedSearch] = useState(null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const previewRequest = useRef(0);
  const validRange = isValidReportRange(searchDocDate, searchEndDate);
  const [searchDlId, setSearchDlId] = useState("");
  const [searchPkRound, setSearchPkRound] = useState("");
  const [dlLineList, setDlLineList] = useState([]);
  const [pWhere, setPWhere] = useState("");

  const [previewDataList, setPreviewDataList] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [includeAdminData, setIncludeAdminData] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [companyData, setCompanyData] = useState(null);
  const [isExportingExcel, setIsExportingExcel] = useState(false);

  const isAllSelected =
    previewDataList.length > 0 &&
    selectedRows.length === previewDataList.length;

  const startIndex = (currentPage - 1) * itemsPerPageDropdown + 1;
  const endIndex = Math.min(
    currentPage * itemsPerPageDropdown,
    filteredData.length
  );

  // สำหรับดูรายละเอียดบัญชีของ PickingList
  const [isVansaleCloseForAccount, setIsVansaleCloseForAccount] =
    useState(false);
  const hideVansaleCloseForAccount = async () => {
    setIsVansaleCloseForAccount(false);
  };
  const [pkId, setPkId] = useState(null);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    setName("8. รายงานนำส่งรายได้");
    setFilteredData([]);
    const dlDataList = await getDataWithComp("DL_Line_H", "ORDER By DL_Id ASC");
    if (dlDataList && dlDataList.length > 0) {
      setDlLineList(dlDataList);
    }
    const companies = await getCompany();
    if (Array.isArray(companies)) {
      const currentCompany = companies.find(
        (item) => String(item.Comp_id ?? item.Comp_Id) === String(window.localStorage.getItem("company"))
      );
      setCompanyData(currentCompany || companies[0] || null);
    }
  };

  const handleExportExcel = async () => {
    if (!filteredData.length) {
      return getAlert("FAILED", "กรุณาค้นหาข้อมูลก่อนพิมพ์ไฟล์ Excel");
    }

    const roundLabels = { 1: "เช้า", 2: "บ่าย", 3: "เย็น" };
    const deliveryLabels = [...new Set(
      filteredData
        .map((item) => {
          if (!item.DL_LineName) return null;
          const round = roundLabels[item.PK_Round];
          return round ? `${item.DL_LineName} (${round})` : item.DL_LineName;
        })
        .filter(Boolean)
    )];

    setIsExportingExcel(true);
    try {
      await ExportVansaleIncomeReport({
        rows: filteredData,
        reportDate: searchDocDate,
        deliveryLabel: deliveryLabels.length > 0 ? deliveryLabels.join(", ") : "ทุกสาย",
        company: companyData,
        isIce,
      });
    } finally {
      setIsExportingExcel(false);
    }
  };

  useEffect(() => {
    if (showConfirmModal) {
      fetchPreviewData(searchDocDate, searchEndDate, searchDlId, searchPkRound);
    }
    return () => { previewRequest.current += 1; };
    // Refresh the preview whenever its filters change, including on opening.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showConfirmModal, searchDocDate, searchEndDate, searchDlId, searchPkRound]);

  const fetchPreviewData = async (date, endDate, dlId, pkRound) => {
    const request = ++previewRequest.current;
    setSelectedRows([]);
    setPreviewDataList([]);
    setIsPreviewLoading(false);
    if (!isValidReportRange(date, endDate)) return;
    setIsPreviewLoading(true);
    let where = `${reportDateCondition("PK_H.Doc_Date", date, endDate)}
            AND PK_H.Comp_Id = '${window.localStorage.getItem("company")}'
            AND PK_H.Doc_Status = 5`;
    if (dlId) where += ` AND PK_H.Delivery_Line_Id = ${dlId}`;
    if (pkRound) where += ` AND PK_H.PK_Round = ${pkRound}`;

    try {
      const result = await getDataWithJoin(
        `
                DISTINCT 
                DL_H.DL_LineName,
                PK_H.Doc_Date,
                PK_H.PK_Round,
                PK_H.Delivery_Line_Id
                `,
        `API_0801_PKList_H AS PK_H`,
        `
                LEFT JOIN API_0802_PKList_D AS PK_D ON PK_H.Doc_Id = PK_D.Doc_Id
                LEFT JOIN API_0701_SO_H AS SO_H ON PK_D.SO_Id = SO_H.Doc_ID
                LEFT JOIN API_0702_SO_D AS SO_D ON SO_H.Doc_ID = SO_D.Doc_ID
                LEFT JOIN DL_Line_H AS DL_H ON PK_H.Delivery_Line_Id = DL_H.DL_Id
                WHERE ${where}
                AND PK_D.SO_Id IS NOT NULL
                GROUP BY 
                    DL_H.DL_LineName, 
                    PK_H.Doc_Date, 
                    PK_H.PK_Round, 
                    PK_H.Delivery_Line_Id
                `,
        ""
      );
      if (request !== previewRequest.current) return;
      if (!Array.isArray(result)) throw new Error("Unable to load report preview");
      setPreviewDataList(result);
    } catch (error) {
      if (request === previewRequest.current) getAlert("FAILED", error.message || error);
    } finally {
      if (request === previewRequest.current) setIsPreviewLoading(false);
    }
  };

  const handleChangeSearchDocDate = (value) => {
    const formattedDate =
      moment.isMoment(value) ? value.format("YYYY-MM-DD") : "";
    setSearchDocDate(formattedDate);
  };

  const handleChangeSearchDlId = (e) => {
    const dlId = e.target.value;
    setSearchDlId(dlId);
  };

  const handleChangeSearchPkRound = (e) => {
    const round = e.target.value;
    setSearchPkRound(round);
  };

  const handleConfirmPreview = async () => {
    if (!validRange || isPreviewLoading || isSearching) return;
    if (!includeAdminData && selectedRows.length === 0) {
      return getAlert("FAILED", "กรุณาเลือกรายการที่ต้องการค้นหา");
    }
    setShowConfirmModal(false);
    await handleSearch();
  };

  const handleSearch = async () => {
    try {
      if (!validRange || isSearching) return;
      if (!includeAdminData && selectedRows.length === 0) return;
      setIsSearching(true);
      setFilteredData([]);
      setFilteredDataSub([]);
      setPWhere("");
      setCurrentPage(1);
      setSelectedRowIndex(0);
      setAppliedSearch({ start: searchDocDate, end: searchEndDate, rows: [...selectedRows], includeAdmin: includeAdminData });
      const where = buildVansaleWhere({
        start: searchDocDate, end: searchEndDate, rows: selectedRows,
        includeAdmin: includeAdminData, company: localStorage.getItem("company"),
      });

      const response = await getDataWithJoin(
        `
                PK_H.Doc_Id,
                PK_H.Doc_No AS PK_No,
                SO_H.Doc_No,
                SO_H.AR_Name,
                --ยอดขาย
                SO_H.Total_Before_Vat,
                SO_H.VAT,
                SO_H.NetTotal,
                --ยอดชำระ
                CASE
                    WHEN SO_H.Doc_Status_Paid_Type = 1 THEN SO_H.Pay_Total
                    WHEN SO_H.Doc_Status_Paid_Type = 2 THEN SO_H.Pay_Total
                    WHEN SO_H.Doc_Status_Paid_Type = 3 THEN SO_H.Pay_Total
                    WHEN SO_H.Doc_Status_Paid_Type = 4 THEN SO_H.NetTotal
                    WHEN SO_H.Doc_Status_Paid_Type = 5 THEN SO_H.NetTotal
                    ELSE 0
                END AS Pay_Total,
                SO_H.Doc_Status_Paid_Type,
                CASE
                    WHEN SO_H.Doc_Status_Paid_Type = 1 THEN 'เงินสด'
                    WHEN SO_H.Doc_Status_Paid_Type = 2 THEN 'โอน'
                    WHEN SO_H.Doc_Status_Paid_Type = 3 THEN 'เช็ค'
                    WHEN SO_H.Doc_Status_Paid_Type = 4 THEN 'เครดิต'
                    WHEN SO_H.Doc_Status_Paid_Type = 5 THEN 'ค้างจ่าย'
                    ELSE 'ไม่ระบุ'
                END AS PaymentType,
                PK_H.Driver1,
                ${
                  isIce
                    ? "SUM(CASE WHEN SO_D.Item_Code = '101' THEN SO_D.Item_Qty ELSE 0 END) AS OEM,\n                SUM(CASE WHEN SO_D.Item_Code = '102' THEN SO_D.Item_Qty ELSE 0 END) AS W_350,\n                SUM(CASE WHEN SO_D.Item_Code = '103' THEN SO_D.Item_Qty ELSE 0 END) AS W_600,\n                SUM(CASE WHEN SO_D.Item_Code = '104' THEN SO_D.Item_Qty ELSE 0 END) AS W_1500,\n                SUM(CASE WHEN SO_D.Item_Code = '105' THEN SO_D.Item_Qty ELSE 0 END) AS W_Bucket,"
                    : "SUM(CASE WHEN SO_D.Item_Code NOT IN ('001','002','003','005') THEN SO_D.Item_Qty ELSE 0 END) AS OEM,\n                SUM(CASE WHEN SO_D.Item_Code = '001' THEN SO_D.Item_Qty ELSE 0 END) AS W_350,\n                SUM(CASE WHEN SO_D.Item_Code = '002' THEN SO_D.Item_Qty ELSE 0 END) AS W_600,\n                SUM(CASE WHEN SO_D.Item_Code = '003' THEN SO_D.Item_Qty ELSE 0 END) AS W_1500,\n                SUM(CASE WHEN SO_D.Item_Code = '005' THEN SO_D.Item_Qty ELSE 0 END) AS W_Bucket,"
                }
                PK_H.PK_Round,
                SO_H.DL_LineName,
                SO_H.Doc_Is_PickingList
                `,
        `API_0701_SO_H SO_H`,
        `
                LEFT JOIN API_0702_SO_D AS SO_D ON SO_H.Doc_ID = SO_D.Doc_ID
                LEFT JOIN API_0801_PKList_H PK_H ON (PK_H.Doc_Id = SO_H.Ref_DocID AND PK_H.Comp_Id = SO_H.Comp_Id)
                WHERE 1 = 1 ${where}
                GROUP BY
                    SO_H.Doc_No,
                    SO_H.Doc_ID,
                    PK_H.Doc_Id,
                    PK_H.Doc_No,
                    SO_H.AR_Name,
                    SO_H.Total_Before_Vat,
                    SO_H.VAT,
                    SO_H.NetTotal,
                    SO_H.Pay_Total,
                    SO_H.Doc_Status_Paid_Type,
                    PK_H.Driver1,
                    PK_H.PK_Round,
                    SO_H.DL_LineName,
                    SO_H.Doc_Is_PickingList
                ORDER BY SO_H.DL_LineName, SO_H.Doc_No ASC
                `,
        ""
      );

      if (!Array.isArray(response)) throw new Error("Unable to load report data");
      if (response.length > 0) {
        setFilteredData(response);

        const docIds = [
          ...new Set(
            response
              .filter((item) => item.Doc_Id !== null)
              .map((item) => item.Doc_Id)
          ),
        ];
        // setDocId(docIds.map(id => `'${id}'`).join(","));
        // setDocId(docIds.join(","));
        setPWhere(where);
        if (docIds.length > 0) {
          const responseSub = await getData(
            `PKList_CloseMoney`,
            `PKList_Id IN (${docIds.join(",")})`
          );

          if (responseSub && responseSub.length > 0) {
            setFilteredDataSub(responseSub);
          } else {
            setFilteredDataSub([]);
          }
        } else {
          setFilteredDataSub([]);
        }
      } else {
        setFilteredData([]);
        setFilteredDataSub([]);
        getAlert("WARNING", "ไม่พบข้อมูล");
      }
    } catch (error) {
      getAlert("FAILED", error.response?.message || error.message);
    } finally {
      setIsSearching(false);
    }
  };

  const handlePrintReport = () => {
    if (!pWhere || isSearching) return;
    getReport("income_a", pWhere);
  };

  const handleItemsPerPageChange = (event) => {
    const newItemsPerPage = parseCurrency(event.target.value);
    setItemsPerPageDropdown(newItemsPerPage);
    setItemsPerPage(newItemsPerPage);
    handlePageChange(1);
  };

  const handleCheckboxChange = (e, item, idx) => {
    if (e.target.checked) {
      setSelectedRows((prev) => [...prev, { ...item, idx }]);
    } else {
      setSelectedRows((prev) =>
        prev.filter((selected) => selected.idx !== idx)
      );
    }
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setSelectedRows(previewDataList.map((item, idx) => ({ ...item, idx })));
    } else {
      setSelectedRows([]);
    }
  };

  return (
    <>
      <Sidebar />
      <div className="main-panel">
        <div className="container">
          <div className="page-inner">
            <div className="page-header d-flex justify-content-between align-items-center">
              <Breadcrumbs
                page={name}
                items={[
                  { name: "รายงาน", url: "/reports" },
                  { name: name, url: "/vansale-report" },
                ]}
              />
            </div>
            <div className="row">
              <div className="card">
                <div className="card-body">
                  <div className="col-md-12 d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-md shadow text-white"
                      style={{
                        width: "10%",
                        backgroundColor: "#EF6C00",
                        fontSize: "16px",
                      }}
                      disabled={isSearching}
                      onClick={() => setShowConfirmModal(true)}
                    >
                      <i className="fas fa-search" /> ค้นหา
                    </button>
                    <button
                      type="button"
                      className="btn btn-md shadow text-white"
                      style={{
                        width: "15%",
                        backgroundColor: "#EF6C00",
                        fontSize: "16px",
                      }}
                      disabled={!pWhere || isSearching}
                      onClick={handlePrintReport}
                    >
                      <i className="fas fa-print" /> พิมพ์รายงานนำส่งรายได้
                    </button>
                    <button
                      type="button"
                      className="btn btn-md shadow text-white"
                      style={{
                        width: "15%",
                        backgroundColor: "#217346",
                        fontSize: "16px",
                      }}
                      onClick={handleExportExcel}
                      disabled={isExportingExcel || filteredData.length === 0}
                    >
                      <i className="fas fa-file-excel" />{" "}
                      {isExportingExcel ? "กำลังสร้าง Excel..." : "พิมพ์ไฟล์ Excel"}
                    </button>
                  </div>
                </div>
              </div>

              {/* Modal การค้นหา */}
              <div
                className={`modal ${showConfirmModal ? "show" : ""}`}
                style={{
                  display: showConfirmModal ? "block" : "none",
                  backgroundColor: "rgba(0,0,0,0.5)",
                }}
                tabIndex="-1"
                role="dialog"
              >
                <div
                  className="modal-dialog modal-lg vansale-search-dialog"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        เลือกช่วงวันที่, สายรถ, รอบส่ง เพื่อสรุปยอดขาย
                      </h5>
                      <button
                        type="button"
                        className="close"
                        onClick={() => setShowConfirmModal(false)}
                      >
                        <span>&times;</span>
                      </button>
                    </div>

                    <div className="modal-body">
                      <div className="vansale-search-filters">
                        <div className="vansale-search-field">
                          <label className="form-label">วันที่เริ่มต้น</label>
                          <DatePicker
                            label=""
                            name="reportStartDate"
                            value={searchDocDate}
                            onChange={(date) => handleChangeSearchDocDate(date)}
                            disabled={false}
                          />
                        </div>

                        <div className="vansale-search-field">
                          <label className="form-label">วันที่สิ้นสุด</label>
                          <DatePicker
                            label=""
                            name="reportEndDate"
                            value={searchEndDate}
                            onChange={(date) => setSearchEndDate(moment.isMoment(date) ? date.format("YYYY-MM-DD") : "")}
                            disabled={false}
                          />
                        </div>

                        <div className="vansale-search-field">
                          <label className="form-label">สายรถ</label>
                          <select
                            className="form-select"
                            value={searchDlId}
                            onChange={handleChangeSearchDlId}
                          >
                            <option value="">ทั้งหมด</option>
                            {dlLineList.map((line) => (
                              <option key={line.DL_Id} value={line.DL_Id}>
                                {line.DL_LineName}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="vansale-search-field">
                          <label className="form-label">ช่วงเวลาส่ง</label>
                          <select
                            className="form-select"
                            value={searchPkRound}
                            onChange={handleChangeSearchPkRound}
                          >
                            <option value="">ทั้งหมด</option>
                            <option value="1">เช้า</option>
                            <option value="2">บ่าย</option>
                            <option value="3">เย็น</option>
                          </select>
                        </div>

                        <div className="vansale-search-admin d-flex align-items-center">
                          <input
                            type="checkbox"
                            checked={includeAdminData}
                            onChange={() =>
                              setIncludeAdminData(!includeAdminData)
                            }
                            id="includeAdminData"
                            style={{
                              marginRight: "8px",
                              width: "18px",
                              height: "18px",
                            }}
                          />
                          <label
                            htmlFor="includeAdminData"
                            style={{ margin: 0 }}
                          >
                            ข้อมูลของแอดมิน
                          </label>
                        </div>
                      </div>

                      {!validRange && (
                        <div className="alert alert-warning" role="alert">
                          กรุณาระบุวันที่เริ่มต้นและวันที่สิ้นสุด โดยวันที่สิ้นสุดต้องไม่ก่อนวันที่เริ่มต้น
                        </div>
                      )}
                      <p className="text-muted">รวมยอดขายตั้งแต่วันที่เริ่มต้นถึงวันที่สิ้นสุด รวมทั้งสองวัน เลือกทั้งหมดเพื่อรวมทุกสายรถและรอบส่งในช่วงนี้</p>

                      {/* ตารางข้อมูลที่แสดงใน Modal */}
                      <div
                        className="table-responsive"
                        style={{ maxHeight: "350px", overflowY: "auto" }}
                      >
                        <table className="table table-striped table-hover">
                          <thead className="thead-dark">
                            <tr>
                              <th
                                className="text-center"
                                style={{ width: "5%" }}
                              >
                                <input
                                  type="checkbox"
                                  checked={isAllSelected}
                                  onChange={handleSelectAllChange}
                                />
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "30%" }}
                              >
                                วันที่
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "30%" }}
                              >
                                สายรถ
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "35%" }}
                              >
                                รอบส่ง
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {previewDataList.length > 0 ? (
                              previewDataList.map((item, idx) => (
                                <tr key={idx}>
                                  <td className="text-center">
                                    <input
                                      type="checkbox"
                                      checked={selectedRows.some(
                                        (selected) => selected.idx === idx
                                      )}
                                      onChange={(e) =>
                                        handleCheckboxChange(e, item, idx)
                                      }
                                    />
                                  </td>
                                  <td className="text-center">
                                    {moment(item.Doc_Date).format("DD-MM-YYYY")}
                                  </td>
                                  <td className="text-center">
                                    {item.DL_LineName}
                                  </td>
                                  <td className="text-center">
                                    {item.PK_Round === 1
                                      ? "เช้า"
                                      : item.PK_Round === 2
                                      ? "บ่าย"
                                      : "เย็น"}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="4" className="text-center">
                                  {isPreviewLoading ? "กำลังโหลดข้อมูล..." : "ไม่พบรายการสายรถที่ปิดรอบแล้วในช่วงวันที่ที่เลือก หากต้องการดูยอดขายของแอดมิน ให้เลือกข้อมูลของแอดมิน"}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        className="btn btn-danger"
                        onClick={() => setShowConfirmModal(false)}
                      >
                        ยกเลิก
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={handleConfirmPreview}
                        disabled={!validRange || isPreviewLoading || isSearching || (!includeAdminData && selectedRows.length === 0)}
                      >
                        ยืนยันค้นหา
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* รายงานที่ค้นหาได้ */}
              <div className="col-md-12 mt-4">
                <div className="card">
                  <div className="card-header">
                    <div className="col-md-12">
                      <div className="d-flex align-items-center flex-wrap">
                        <i className="fas fa-calendar-day text-primary" />
                        <h4 className="font-weight-bold">วันที่</h4>&nbsp;
                        <h4>{appliedSearch ? `${formatDateCheque(appliedSearch.start)} - ${formatDateCheque(appliedSearch.end)}` : "-"}</h4>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <i className="fas fa-bus text-success me-2" />
                      <span
                        className="font-weight-bold"
                        style={{ fontSize: "16px" }}
                      >
                        สายรถ:{" "}
                      </span>
                      <span style={{ fontSize: "16px" }}>
                        {dlLineList
                          .filter((line) =>
                            (appliedSearch?.rows || []).some(
                              (row) => row.Delivery_Line_Id === line.DL_Id
                            )
                          )
                          .map((line) => {
                            const rounds = (appliedSearch?.rows || [])
                              .filter(
                                (row) => row.Delivery_Line_Id === line.DL_Id
                              )
                              .map((row) => {
                                switch (row.PK_Round) {
                                  case 1:
                                    return "เช้า";
                                  case 2:
                                    return "บ่าย";
                                  case 3:
                                    return "เย็น";
                                  default:
                                    return "";
                                }
                              })
                              .join(", ");
                            return `${line.DL_LineName} (${[...new Set(rounds.split(", "))].join(", ")})`;
                          })
                          .join(", ")}
                        {appliedSearch?.includeAdmin && " (รวมข้อมูลของแอดมิน)"}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "auto", overflowY: "auto" }}
                    >
                      <table
                        id="basic-datatables"
                        className="table table-striped table-hover"
                      >
                        <thead className="thead-dark">
                          <tr>
                            <th rowSpan={2} className="text-center">
                              สาย/รอบ
                            </th>
                            <th rowSpan={2} className="text-center">
                              เลขที่ใบขาย
                            </th>
                            <th rowSpan={2} className="text-center">
                              เลขที่ใบ PK
                            </th>
                            <th rowSpan={2} className="text-center">
                              รายชื่อลูกค้า
                            </th>
                            <th rowSpan={2} className="text-center">
                              ผู้จัดส่ง
                            </th>
                            <th colSpan={5} className="text-center">
                              {isIce ? "รายการสินค้าโรงน้ำแข็ง" : "รายการสินค้า IDRINK"}
                            </th>
                            <th colSpan={3} className="text-center">
                              ยอดขาย
                            </th>
                            <th colSpan={5} className="text-center">
                              การชำระ
                            </th>
                          </tr>
                            <tr>
                            <th className="text-center">{isIce ? "หลอดใหญ่" : "OEM"}</th>
                            <th className="text-center">{isIce ? "หลอดเล็ก" : "350ml"}</th>
                            <th className="text-center">{isIce ? "บดใหญ่" : "600ml"}</th>
                            <th className="text-center">{isIce ? "บดเล็ก" : "1500ml"}</th>
                            <th className="text-center">{isIce ? "แพ็คถุง" : "น้ำถัง"}</th>
                            <th className="text-center">ยอดขาย / บาท</th>
                            <th className="text-center">Vat</th>
                            <th className="text-center">รวมยอดทั้งหมด / บาท</th>
                            <th className="text-center">เงินสด</th>
                            <th className="text-center">โอน</th>
                            <th className="text-center">เครดิต</th>
                            <th className="text-center">เช็ค</th>
                            <th className="text-center">ค้างจ่าย</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.length > 0 ? (
                            currentItems.map((data, index) => {
                              const rowId = data.Doc_No || index + 1;
                              return (
                                <tr
                                  key={rowId}
                                  style={{
                                    cursor: "pointer",
                                    backgroundColor:
                                      selectedRow === rowId
                                        ? "rgb(105, 188, 216)"
                                        : "transparent",
                                    transition: "background-color 0.3s ease",
                                  }}
                                  onClick={() => setSelectedRow(rowId)}
                                >
                                  <td className="text-center">
                                    {(() => {
                                      const roundMapping = {
                                        1: "เช้า",
                                        2: "บ่าย",
                                        3: "เย็น",
                                      };
                                      return (
                                        (data.DL_LineName || "-")
                                          .concat("/")
                                          .concat(
                                            roundMapping[data.PK_Round] || "-"
                                          ) || "-"
                                      );
                                    })()}
                                  </td>

                                  <td className="text-center">
                                    {data.Doc_No || "-"}
                                  </td>

                                  <td
                                    className="text-center"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    {data.PK_No || "-"}
                                    {data.PK_No && (
                                      <>
                                        <button
                                          className="btn btn-link btn-sm px-1"
                                          onClick={() => {
                                            setIsVansaleCloseForAccount(true);
                                            setPkId(data.Doc_Id);
                                          }}
                                          style={{ marginLeft: "auto" }}
                                        >
                                          <i
                                            className="fa fa-search"
                                            style={{ fontSize: "16px" }}
                                          ></i>
                                        </button>
                                      </>
                                    )}
                                  </td>

                                  <td className="text-left">
                                    {data.AR_Name || "-"}
                                  </td>

                                  <td className="text-left">
                                    {data.Driver1 || "-"}
                                  </td>

                                  <td className="text-center">
                                    {data.OEM || "-"}
                                  </td>

                                  <td className="text-center">
                                    {data.W_350 || "-"}
                                  </td>

                                  <td className="text-center">
                                    {data.W_600 || "-"}
                                  </td>

                                  <td className="text-center">
                                    {data.W_1500 || "-"}
                                  </td>

                                  <td className="text-center">
                                    {data.W_Bucket || "-"}
                                  </td>

                                  <td className="text-end">
                                    {formatCurrency(
                                      data.Total_Before_Vat || 0.0
                                    ) || "-"}
                                  </td>

                                  <td className="text-end">
                                    {data.VAT
                                      ? formatCurrency(data.VAT || 0.0)
                                      : "-"}
                                  </td>

                                  <td className="text-end">
                                    {formatCurrency(data.NetTotal || 0.0)}
                                  </td>

                                  <td className="text-end">
                                    {formatCurrency(
                                      data.PaymentType === "เงินสด"
                                        ? data.Pay_Total
                                        : 0.0 || "-"
                                    )}
                                  </td>

                                  <td className="text-end">
                                    {formatCurrency(
                                      data.PaymentType === "โอน"
                                        ? data.Pay_Total
                                        : 0.0 || "-"
                                    )}
                                  </td>

                                  <td className="text-end">
                                    {formatCurrency(
                                      data.PaymentType === "เครดิต"
                                        ? data.Pay_Total
                                        : 0.0 || "-"
                                    )}
                                  </td>

                                  <td className="text-end">
                                    {formatCurrency(
                                      data.PaymentType === "เช็ค"
                                        ? data.Pay_Total
                                        : 0.0 || "-"
                                    )}
                                  </td>

                                  <td className="text-end">
                                    {formatCurrency(
                                      data.PaymentType === "ค้างจ่าย"
                                        ? data.Pay_Total
                                        : 0.0 || "-"
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={18}>
                                <center>
                                  <h5>ไม่พบข้อมูล</h5>
                                </center>
                              </td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot className="table-primary">
                          <tr>
                            <td colSpan={5} className="text-end">
                              <b>รวมทั้งช่วงวันที่</b>
                            </td>
                            {[
                              "OEM",
                              "W_350",
                              "W_600",
                              "W_1500",
                              "W_Bucket",
                            ].map((item) => (
                              <td className="text-center" key={item}>
                                <b>
                                  {filteredData.reduce((sum, data) => {
                                    if (item === "OEM") {
                                      const value = data.OEM
                                        ? parseCurrency(data.OEM)
                                        : 0;
                                      return sum + (isNaN(value) ? 0 : value);
                                    } else if (item === "W_350") {
                                      const value = data.W_350
                                        ? parseCurrency(data.W_350)
                                        : 0;
                                      return sum + (isNaN(value) ? 0 : value);
                                    } else if (item === "W_600") {
                                      const value = data.W_600
                                        ? parseCurrency(data.W_600)
                                        : 0;
                                      return sum + (isNaN(value) ? 0 : value);
                                    } else if (item === "W_1500") {
                                      const value = data.W_1500
                                        ? parseCurrency(data.W_1500)
                                        : 0;
                                      return sum + (isNaN(value) ? 0 : value);
                                    } else if (item === "W_Bucket") {
                                      const value = data.W_Bucket
                                        ? parseCurrency(data.W_Bucket)
                                        : 0;
                                      return sum + (isNaN(value) ? 0 : value);
                                    }
                                    return sum;
                                  }, 0)}
                                </b>
                              </td>
                            ))}

                            {/* ยอดขาย */}
                            <td className="text-end">
                              <b>
                                {formatCurrency(
                                  filteredData.reduce((sum, data) => {
                                    const value = parseCurrency(
                                      data.Total_Before_Vat
                                    );
                                    return sum + (isNaN(value) ? 0 : value);
                                  }, 0)
                                )}
                              </b>
                            </td>

                            {/* VAT */}
                            <td className="text-end">
                              <b>
                                {formatCurrency(
                                  filteredData.reduce((sum, data) => {
                                    const value = parseCurrency(data.VAT);
                                    return sum + (isNaN(value) ? 0 : value);
                                  }, 0)
                                )}
                              </b>
                            </td>

                            {/* รวมยอดทั้งหมด */}
                            <td className="text-end">
                              <b>
                                {formatCurrency(
                                  filteredData.reduce((sum, data) => {
                                    const value = parseCurrency(data.NetTotal);
                                    return sum + (isNaN(value) ? 0 : value);
                                  }, 0)
                                )}
                              </b>
                            </td>

                            {/* การชำระ */}
                            {[
                              "เงินสด",
                              "โอน",
                              "เครดิต",
                              "เช็ค",
                              "ค้างจ่าย",
                            ].map((paymentType) => (
                              <td className="text-end" key={paymentType}>
                                <b>
                                  {formatCurrency(
                                    filteredData.reduce((sum, data) => {
                                      const value =
                                        data.PaymentType === paymentType
                                          ? parseCurrency(data.Pay_Total)
                                          : 0;
                                      return sum + (isNaN(value) ? 0 : value);
                                    }, 0)
                                  )}
                                </b>
                              </td>
                            ))}
                          </tr>
                        </tfoot>
                      </table>

                      <CloseVansaleForAccountModal
                        isVansaleCloseForAccount={isVansaleCloseForAccount}
                        hideVansaleCloseForAccount={hideVansaleCloseForAccount}
                        pkId={pkId}
                        docStatus={5}
                        setDocStatus={() => {}}
                        callInitialize={() => {}}
                      />

                      {/* Footer */}
                      <div className="d-flex justify-content-between align-items-center p-3">
                        {/* ตัวเลือกจำนวนแถว */}
                        <div>
                          <select
                            value={itemsPerPageDropdown}
                            onChange={handleItemsPerPageChange}
                            className="form-select"
                          >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                        </div>

                        {/* การแสดงจำนวนข้อมูล */}
                        <div>
                          <span>
                            แสดง {startIndex}-{endIndex} ของ{" "}
                            {filteredData.length.toLocaleString()} รายการ
                          </span>
                        </div>

                        {/* Pagination */}
                        <Pagination
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                          itemsPerPage={itemsPerPageDropdown}
                          dataMasterList={filteredData}
                          handlePageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 mt-4">
              <div className="card">
                <div className="card-body">
                  <div
                    className="table-responsive"
                    style={{ maxHeight: "550px", overflowY: "auto" }}
                  >
                    <table
                      id="basic-datatables"
                      className="table table-striped table-hover"
                      style={{ width: "30%", margin: "auto" }}
                    >
                      <thead className="thead-dark">
                        <tr>
                          <th className="text-center">สรุปยอดเงิน</th>
                          <th className="text-center">จำนวนธนบัตร/เหรียญ</th>
                          <th className="text-center">จำนวนเงินรวม</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredDataSub.length > 0 ? (
                          (() => {
                            // คำนวณผลรวมธนบัตร
                            const total = filteredDataSub.reduce(
                              (acc, curr) => ({
                                B1000: (acc.B1000 || 0) + (curr.B1000 || 0),
                                B500: (acc.B500 || 0) + (curr.B500 || 0),
                                B100: (acc.B100 || 0) + (curr.B100 || 0),
                                B50: (acc.B50 || 0) + (curr.B50 || 0),
                                B20: (acc.B20 || 0) + (curr.B20 || 0),
                                B10: (acc.B10 || 0) + (curr.B10 || 0),
                                B5: (acc.B5 || 0) + (curr.B5 || 0),
                                B2: (acc.B2 || 0) + (curr.B2 || 0),
                                B1: (acc.B1 || 0) + (curr.B1 || 0),
                              }),
                              {}
                            );

                            // คำนวณยอดรวมทั้งหมด
                            const sumTotalMoney = Object.entries(total).reduce(
                              (acc, [key, value]) =>
                                acc + value * parseCurrency(key.slice(1), 10),
                              0
                            );

                            // สร้างตารางแสดงข้อมูล
                            const denominations = [
                              {
                                name: "1,000 บาท",
                                key: "B1000",
                                value: total.B1000,
                              },
                              {
                                name: "500 บาท",
                                key: "B500",
                                value: total.B500,
                              },
                              {
                                name: "100 บาท",
                                key: "B100",
                                value: total.B100,
                              },
                              { name: "50 บาท", key: "B50", value: total.B50 },
                              { name: "20 บาท", key: "B20", value: total.B20 },
                              { name: "10 บาท", key: "B10", value: total.B10 },
                              { name: "5 บาท", key: "B5", value: total.B5 },
                              { name: "2 บาท", key: "B2", value: total.B2 },
                              { name: "1 บาท", key: "B1", value: total.B1 },
                            ];

                            return (
                              <>
                                {denominations.map((denomination) => (
                                  <tr key={denomination.key}>
                                    <td className="text-center">
                                      {formatCurrency(denomination.name)}
                                    </td>
                                    <td className="text-center">
                                      {denomination.value}
                                    </td>
                                    <td className="text-end">
                                      {formatCurrency(
                                        denomination.value *
                                          parseCurrency(
                                            denomination.name.split(" ")[0],
                                            10
                                          )
                                      )}
                                    </td>
                                  </tr>
                                ))}
                                <tr className="table-primary">
                                  <td className="text-end" colSpan="2">
                                    <b>รวม</b>
                                  </td>
                                  <td className="text-end">
                                    <b>{formatCurrency(sumTotalMoney)}</b>
                                  </td>
                                </tr>
                              </>
                            );
                          })()
                        ) : (
                          <tr>
                            <td colSpan={17}>
                              <center>
                                <h5>ไม่พบข้อมูล</h5>
                              </center>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VansaleReport;
